<div id="openExtendsHotelbookings" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Reservas de hotel <span class="badge badge-checkin f-s-12 m-l-5">CHECK-IN
            CONFIRMADAS</span></h4>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
      </div>
      <app-loading-modal></app-loading-modal>
      <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead class="thead-default">
                    <tr>
                      <th>Código reserva</th>
                      <th class="text-center">Tipo Hab.</th>
                      <th class="text-center">N° Hab.</th>
                      <th>Responsable</th>
                      <th>CHECK-IN</th>
                      <th>CHECK-OUT</th>
                      <th class="text-center">Selec.</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="bookings.length == 0">
                      <tr>
                        <td colspan="7"><span>No se encontraron registros</span></td>
                      </tr>
                    </ng-container>
                    <ng-container *ngIf="bookings.length > 0">
                      <tr *ngFor="let item of bookings; let index_ = index">
                        <td>{{item.booking_data.code}}</td>
                        <td class="text-center"><span class="bold">{{item.roomtype.description}}</span></td>
                        <td class="text-center"><span class="f-s-15 bold">{{item.bedroom.code_number}}</span></td>
                        <td>
                          <p class="m-b-0 f-s-12" style="line-height: 1.3em;">{{item.booking_data.client_data.fullname}}</p>
                          <p class="bold f-s-10 m-b-0">DOC : {{item.booking_data.client_data.document}}
                          </p>
                        </td>
                        <td>{{item.date_checkin | date: 'mediumDate'}}</td>
                        <td>{{item.date_checkout | date: 'mediumDate'}}</td>
                        <td class="text-center">
                          <i (click)="selectBook(item)" class="fas fa-check-circle f-s-20 text-success pointer"></i>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal" (click)="close()">Cerrar
            ventana</button>
        </div>
      </form>
    </div>
  </div>
</div>

